<script setup lang="ts">
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
import type { Icon } from "@/model/icon";

defineProps<{ text: string; iconBefore?: Icon; sub?: boolean }>();
</script>

<template>
  <div class="list-header-content" :class="{ sub }">
    <SvgIcon
      v-if="iconBefore"
      :name="iconBefore"
      width="16"
      height="16"
      class="icon-before"
      aria-hidden="true"
    />
    <div>{{ text }}</div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/mixins/typography";
@use "@/styles/mixins/utils";
@use "@/styles/variables/colors";

.list-header-content {
  @include typography.medium("bold");

  color: colors.$text;
  max-width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;

  &.sub {
    @include typography.small("semi-bold");

    color: colors.$text-subtle;
  }

  svg {
    flex-shrink: 0;
  }

  & > div {
    @include utils.ellipsis;
  }
}
</style>
